<template>
  <div v-if="showing">
    <div>
      <modal-mask></modal-mask>
    </div>
    <div class="no-leaving">
      <img class="modal-bg" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['noLeavingWinPicture']['bg'][0]}`" alt="">
      <img class="stay-btn" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['noLeavingWinPicture']['btn'][0]}`" alt="" @click="_close">
      <div class="leaving-btn" @click="_leave">离开</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'
import ModalMask from '@/components/modal/ModalMask'
import appBridge from '@/config/appBridge'
import { global } from '@/config/global'

export default {
  name: 'NoLeaving',
  components: {
    ModalMask
  },
  data () {
    return {
      baseUrl,
      showing: false
    }
  },
  mounted () {
    this.$sensors.track('app_popup_show', {popup_name : 'retention'})
  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath', 'activityID'])
  },
  methods: {
    show () {
      this.showing = true
    },
    _close () {
      this.$sensors.track('app_popup_click', {popup_name : 'retention', button_name: 'back'})

      localStorage.setItem(`${global.LOCAL_STORAGE_NO_LEAVING}-${this.activityID}`, true);

      this.showing = false
    },
    _leave () {
      this.$sensors.track('app_popup_click', {popup_name : 'retention', button_name: 'leave'})

      localStorage.setItem(`${global.LOCAL_STORAGE_NO_LEAVING}-${this.activityID}`, true);

      appBridge.closeWebView()
    }
  }
}
</script>

<style scoped lang="less">
  @import '../../style/mixin';
  .no-leaving {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 28.2rem; /* 固定宽度 */
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1000;
  }

  .modal-bg {
    width: 100%; /* 背景图片宽度适配组件 */
    height: auto; /* 高度由图片本身决定 */
  }

  .stay-btn {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
  }

  .leaving-btn {
    width: 9rem;
    height: 2.8rem;
    line-height: 2.8rem;
    border-radius: 2.4rem;
    border: 1px solid #A9ABB3;
    text-align: center;
    font-size: 1.5rem;
    color: #A9ABB3;
    background: transparent;
    position: absolute;
    bottom: calc(-2.8rem - 0.6rem);
    left: 50%;
    transform: translateX(-50%);
  }

</style>